export default __webpack_public_path__ + "static/media/rent_car.9aa1b529.png";